import { __DEV__ } from '@/constants'
import { recordException } from '@/utils/sentry'
import { type ZodRawShape, z } from 'zod'

const errorBuilder = (
  data: Record<string, unknown>,
  dataName: string,
  zodError: Error
) => {
  // eslint-disable-next-line no-console
  if (__DEV__) console.warn('Zod illegal keys in ' + dataName + ':', JSON.stringify(data, null, 2), zodError)
  else recordException(zodError)
}

export const zodErrorParser = (
  dataName: string,
  zod: z.ZodObject<ZodRawShape>,
  data: Record<string, unknown> | Record<string, unknown>[]
) => {
  // Use setTimeout to prevent blocking the main thread
  setTimeout(() => {
    // Find the first error and return to prevent multiple errors to sentry
    (Array.isArray(data) ? data : [data]).find((d, i) => {
      const zodData = zod.safeParse(d)
      if (!zodData.success) {
        const error = new Error(
          `ZodError in ${dataName}`,
          { cause: zodData.error }
        )
        errorBuilder(d, `${dataName}[${i}]`, error)
        return true
      }
      return false
    })
  }, 0)
}
